import React from 'react'
import { Link } from 'react-router-dom'

export default class extends React.Component {
    render() {

		return <span>
			<Link className="small clickable text-mid-gray" to='/me'>
				View Private Profile
			</Link>
		</span>
	}
}


// WEBPACK FOOTER //
// ./src/js/views/Profile/components/ActionButtons/components/ViewPrivate.jsx